export const email = 1;
export const sms = 2;
export const push = 3;
export const statusSeite = 4;
